import { render, staticRenderFns } from "./PendingPrescriptions.vue?vue&type=template&id=47c33f4c&scoped=true&"
import script from "./PendingPrescriptions.vue?vue&type=script&lang=js&"
export * from "./PendingPrescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c33f4c",
  null
  
)

export default component.exports